export default __webpack_public_path__ + "static/media/iconmonstr-linkedin-1.df11cd6f.svg";